import AppItemType from './app-item-type';
import FormViewType from './form-view-type.js';
import { CreateUUID, IsNull } from '@/utils/utils.js';

export default class DataFormParameters {
    constructor(data) {
        this.isShowButtons = true;
        if (data['isShowButtons'] != undefined) {
            this.isShowButtons = data['isShowButtons'];
        }
        this.cardType = data['cardType'];
        this.formCode = data['formCode'];
        this.dataId = data['dataId'];
        this.flowId = data['flowId'];
        this.appItemType = data['appItemType'];
        this.formViewType = data['formViewType'];
        this.isWorkFlow = this.appItemType === AppItemType.WorkflowList;

        this.isMailList = this.appItemType === AppItemType.MailList;
        this.emailType = data['emailType'];

        this.isSubForm = data['isSubForm'];
        this.isSubCommentTable = data['isSubCommentTable']; //是否为评论子表

        this.subAppItemType = data['subAppItemType'];
        this.subCode = data['subCode'];
        this.subDataID = data['subDataID'];

        this.isUnfinish = data['isUnfinish'];
        this.workItemId = data['workItemId'];
        this.workflowVersion = data['workflowVersion'];
        this.state = data['state'];
        this.mainFormDataSource = data['mainFormDataSource'];
        this.rowData = data['rowData'];
        this.isViewMode = this.formViewType === FormViewType.View;

        this.formExtensionInfo = data['formExtensionInfo'];
        this.buttonSetting = data['buttonSetting'];

        if (!this.isWorkFlow || (!this.isSubForm && this.formViewType === FormViewType.Add)) {
            this.flowId = undefined;
        } else if (
            this.isWorkFlow &&
            this.appItemType === AppItemType.WorkflowList &&
            IsNull(this.flowId)
        ) {
            // 没有流程ID的工作流数据打开表单时，统一转成非工作流普通数据
            if (!this.isSubForm) {
                this.isWorkFlow = false;
                this.appItemType = AppItemType.GridList;
            }
        }

        if (this.formViewType === FormViewType.Add) {
            if (this.isSubForm) {
                this.subDataID = CreateUUID();
            } else {
                this.dataId = CreateUUID();
            }
        }
    }
}